export const selectSettingsState = (state) => state.settings || {};
export const selectAccountSettings = (state) => selectSettingsState(state).accountSettings;